module.exports = __webpack_public_path__ + "img/forgot-password.987de04d.svg";